import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppNew } from './AppNew';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
// Tailwind CSS：本地构建，替代原 cdn.tailwindcss.com（避免 CDN 超时导致样式丢失）
import './styles/tailwind.css';

if (import.meta.env.DEV) {
  const __GLOBAL_REACT_KEY = '__BONGAI_REACT_INSTANCE__';
  const currentReact = (window as any)[__GLOBAL_REACT_KEY];
  if (currentReact && currentReact !== React) {
    console.error(
      '[BONG·AI] 检测到 React 多实例！这会导致 "Invalid hook call" 错误。\n' +
      '  已有实例:', currentReact.version, '\n' +
      '  新实例:', React.version, '\n' +
      '  请检查 vite.config.ts 的 alias/dedupe 配置，并清理 node_modules/.vite 缓存。'
    );
  } else if (!currentReact) {
    (window as any)[__GLOBAL_REACT_KEY] = React;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
      <AppNew />
    </ErrorBoundary>
  </QueryClientProvider>
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('[SW] Registered:', reg.scope);
    }).catch((err) => {
      console.warn('[SW] Registration failed:', err);
    });
  });
}
